import api from './api';

export interface Email {
  emailID: number;
  kontoID: number;
  messageID: string;
  betreffText: string;
  absenderName?: string;
  absenderEmail?: string;
  empfaengerEmail?: string;
  empfangenAm: string;
  gelesen: boolean;
  wichtig: boolean;
  beantwortet: boolean;
  hasAttachments: boolean;
  istGesendet?: boolean;
}

export const emailService = {
  // Get all emails
  async getAll(): Promise<Email[]> {
    try {
      const response = await api.get<Email[]>('/emails');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der E-Mails:', error);
      return [];
    }
  },

  // Get emails assigned to a project
  async getByProject(projectId: number): Promise<Email[]> {
    try {
      const response = await api.get<Email[]>(`/projects/${projectId}/mails`);
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der zugeordneten E-Mails:', error);
      return [];
    }
  },
};
